import type { VodBundleDtoBundleSingleView } from '@bldsoft/cappie/api/wbs'
import type { PurchaseInfo, VodBundleInfo } from '@setplex/tria-api'

import { getBackgroundImage, getHorizontalImage } from '../../utils/images'
import { formatPriceSettings } from '../../utils/payment'

export const formatVodBundle = (
  bundle: VodBundleDtoBundleSingleView
): VodBundleInfo => {
  return {
    id: bundle.id!,
    name: bundle.name!,
    description: bundle.description,
    landscapeImageUrl: getHorizontalImage(bundle.coverImageUrl),
    backgroundImageUrl: getBackgroundImage(bundle.coverImageUrl),
    contentQuantity: bundle.contentQuantity!,
    updatedTime: bundle.updatedTime!,
    purchaseInfo: bundle.purchaseInfo as PurchaseInfo,
    vodIds: bundle.vodIds!,
    priceSettings: formatPriceSettings(bundle.priceSettings) || [],
    free: Number(bundle.priceSettings!.length) === 0,
    externalId: bundle.externalId,
  } as VodBundleInfo
}
